module.exports = __webpack_public_path__ + "media/images/pic/anime/slide-fcbd0fa2595588c7a177a319a49cdb88.svg";